import { AppointmentInterface } from '@app/core/interfaces/appointment.interface';
import { ClaimAppointmentInterface } from '@app/my-zone/pages/claims/store/entity/appointment.interface';
import { ClaimEventInterface } from '@app/my-zone/pages/claims/store/entity/claim-event.interface';
import { type } from '@app/store/util';
import { Action } from '@ngrx/store';

export const LOAD = type('[Appointments] Load Appointments');
export const LOAD_SUCCESS = type('[Appointments] Load Appointments Success');

export const SET = type('[Appointments] Set Appointments');
export const SET_SUCCESS = type('[Appointments] Set Appointments Success');

export const SET_ERRORS = type('[Appointments] Set Errors');
export const CLEAR_ERRORS = type('[Appointments] Clear Errors');

export class Load implements Action {
    public type: string = LOAD;
    constructor(public payload: { dossier_volgnummer: number }) {}
}

export class LoadSuccess implements Action {
    public type: string = LOAD_SUCCESS;
    constructor(public payload: { afspraken: ClaimAppointmentInterface[], dossier_volgnummer: number }) {}
}

export class Set implements Action {
    public type: string = SET;
    constructor(public payload: {
        adres_relatie_id: number,
        schadeherstel_gebeurtenis: any[],
        dossier_volgnummer: number,
        netwerk_id: string,
        claim_volgnummer: number,
        gebeurtenis: ClaimEventInterface,
        schadeherstel_soort_vervangend_vervoer_code: string,
    }) {}
}

export class SetSuccess implements Action {
    public type: string = SET_SUCCESS;
    constructor(public payload: {
        adres_relatie_id: number,
        schadeherstel_gebeurtenis: any[],
        dossier_volgnummer: number,
        netwerk_id: string,
        claim_volgnummer: number
        gebeurtenis: ClaimEventInterface,
    }) {}
}

export class SetErrors implements Action {
    public type: string = SET_ERRORS;
    constructor(public payload: { dossier_volgnummer: number, errors: any[] } ) {}
}

export class ClearErrors implements Action {
    public type: string = CLEAR_ERRORS;
    constructor(public payload: any) {}
}

export type Actions
    = Load
    | LoadSuccess
    | Set
    | SetSuccess
    | SetErrors
    | ClearErrors;
